interface Segment {
  value: string;
  label: string;
}

interface SegmentedTabsProps {
  segments: Segment[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export default function SegmentedTabs({
  segments,
  value,
  onChange,
  className = "",
}: SegmentedTabsProps) {
  return (
    <div
      className={`inline-flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1 ${className}`}
    >
      {segments.map((segment) => (
        <button
          key={segment.value}
          type="button"
          onClick={() => onChange(segment.value)}
          className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
            value === segment.value
              ? "bg-primary-500 text-background-50"
              : "text-foreground-600 hover:text-primary-600"
          }`}
        >
          {segment.label}
        </button>
      ))}
    </div>
  );
}